/*!
 * fixxer.js
 *
 * # description
 * allows simple renaming / replacing / extending of the actually queried file name
 * to e.g. add a version suffix/prefix to it like turbo.js -> turbo.v3.2.1.js
 *
 *
 * # config
 *
 * add config to require.config
 *
 * requirejs.config({
 *    ...
 *    config: {
 *      fixxer: {
 *
 *      }
 *    }
 * })
 *
 *
 * # about
 * the name fixxer is a wordplay with prefix, suffix and "to fix up" in the meaning of
 * extending, enhancing something.
 *
 *
 * based on
 * require.replace.js - https://github.com/SBoudrias/require.replace
 *
 * Copyright (c) 2016, Andreas Bernhard
 * Licensed under the MIT license.
 */
(function () {
    "use strict";

    var toString = Object.prototype.toString;

    var aIndexOf = Array.prototype.indexOf || function( needle ) {
            for(var i = 0; i < this.length; i++) {
                if( this[i] === needle ) {
                    return i;
                }
            }
            return -1;
        };

    define('fixxer',{
        version: "0.1.0",

        // ---
        // Called when a dependency needs to be loaded.

        load: function (name, req, onLoad, config) {

            if(config.isBuild || !config.config.fixxer) {

                // dont do anything
                var toLoad = [name];

            }else{

                // if( !config.config.fixxer ) {
                //     throw new Error("Require.fixxer need to be configured");
                // }

                var replaceConfig = config.config.fixxer,
                    configFixxed = config.fixxed = config.fixxed || {},
                    moduleConfig  = replaceConfig[name] || replaceConfig,
                    shouldRun = !config.isBuild,
                    pattern, prefix, suffix, value, path,
                    tmpName,
                    toLoad = [];

                (function() {

                    // Skip if we"re in build process
                    if (!shouldRun ) return;

                    if (configFixxed[name]) {

                        path = configFixxed[name];

                    } else {

                        value = moduleConfig.value || "";

                        if (toString.call(moduleConfig.value) === "[object Function]") {
                            value = moduleConfig.value(name);
                        }

                        // skip if the `value` is contained in the ignored value list
                        if (moduleConfig.ignore
                            && aIndexOf.call(moduleConfig.ignore, value) >= 0) return;

                        pattern = moduleConfig.pattern || null;
                        prefix = moduleConfig.prefix || "";
                        suffix = moduleConfig.suffix || "";

                        if (pattern || prefix || suffix) {
                            // If there's a `paths` config, use it
                            tmpName = name;


                            if (config.paths[name]) {
                                // @note: This override the defined path config to work with shimmed
                                //        modules.
                                //config.paths[name] = config.paths[name].replace( pattern, value );
                                tmpName = config.paths[name];
                            }

                            path = prefix + tmpName.replace(pattern, value) + suffix;

                            if (config.paths[name]) {
                                // @note: This override the defined path config to work with shimmed
                                //        modules.

                                config.paths[name] = path;
                                path = name;

                            }

                        } else {

                            path = name;

                        }

                        configFixxed[name] = path;

                    }

                    toLoad.push( path );

                }());

            }

            req(toLoad, function ( value ) {
                onLoad( value );
            });
        }
    });
}());
